if (!customElements.get("swipe-compare")) {
  class SwipeCompare extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.listenerController = new AbortController();
      this.auto = this.dataset.autoSwipe;
      this.slider = this.querySelector("#swipe-compare__slider");
      this.button = this.querySelector(".swipe-compare__button");
      this.overlay_image = this.querySelector(".swipe-compare__image--after");
      this.base_image = this.querySelector(".swipe-compare__image--before");
      this.bindEvents();
      this.initTimeout = setTimeout(() => this.setSliderSizes(), 1000);
    }

    disconnectedCallback() {
      this.listenerController.abort();
      this.resizeObserver?.disconnect();
      clearTimeout(this.initTimeout);
      clearTimeout(this.autoSwipeTimeout);
    }

    bindEvents() {
      let t = this;
      if (this.slider) {
        this.slider.addEventListener("input", t.manualSwipe.bind(t), { signal: this.listenerController.signal });
      }
      if (t.auto == "true") {
        t.autoSwipe();
      }
      this.resizeObserver = new ResizeObserver(() => t.setSliderSizes());
      this.resizeObserver.observe(t.base_image);
    }

    swipe(sliderPos) {
      const barFactor = 32 * sliderPos * 0.01;
      this.overlay_image.style.width = `calc(${sliderPos}% - ${barFactor}px )`;
      if (this.button) {
        this.button.style.left = `calc(${sliderPos}% - var(--button-radio, 20px))`;
      }
      let currentColumn = this.dataset.currentColumn;
      let newColumn = "right";
      if (sliderPos > 50) {
        newColumn = "left";
      }
      if (newColumn != currentColumn) {
        this.dataset.currentColumn = newColumn;
      }
    }

    autoSwipe() {
      let t = this;
      if (t.auto == "true") {
        let newValue = 0;
        if (t.slider.value < 100) {
          newValue = parseInt(t.slider.value) + 1;
        }
        this.autoSwipeTimeout = setTimeout(() => {
          t.swipe(newValue);
          t.slider.value = newValue;
          t.autoSwipe();
        }, "100");
      }
    }

    manualSwipe() {
      this.swipe(this.slider.value);
      this.auto = false;
    }

    setSliderSizes() {
      let sliderHeight = parseInt(this.base_image.offsetHeight) + "px";
      let sliderWidth = parseInt(this.base_image.offsetWidth) + "px";
      this.style.setProperty("--swipe-compare__slider--height", sliderHeight);
      this.style.setProperty("--swipe-compare__after-width", sliderWidth);
    }
  }

  customElements.define("swipe-compare", SwipeCompare);
}
